export const AUTH_SET_USER_PROFILE = 'auth/SET_USER_PROFILE';
export const AUTH_SET_LOADING = 'auth/SET_LOADING';
export const AUTH_LOGOUT = 'auth/LOGOUT';

export const AUTH_BOOTSTRAP_SESSION_REQUEST = 'auth/BOOTSTRAP_SESSION_REQUEST';
export const AUTH_BOOTSTRAP_SESSION_SUCCESS = 'auth/BOOTSTRAP_SESSION_SUCCESS';
export const AUTH_BOOTSTRAP_SESSION_FAILURE = 'auth/BOOTSTRAP_SESSION_FAILURE';

export const AUTH_LOGIN_REQUEST = 'auth/LOGIN_REQUEST';
export const AUTH_LOGIN_SUCCESS = 'auth/LOGIN_SUCCESS';
export const AUTH_LOGIN_FAILURE = 'auth/LOGIN_FAILURE';

export const AUTH_REGISTER_REQUEST = 'auth/REGISTER_REQUEST';
export const AUTH_REGISTER_SUCCESS = 'auth/REGISTER_SUCCESS';
export const AUTH_REGISTER_FAILURE = 'auth/REGISTER_FAILURE';

export const AUTH_FETCH_ME_REQUEST = 'auth/FETCH_ME_REQUEST';
export const AUTH_FETCH_ME_SUCCESS = 'auth/FETCH_ME_SUCCESS';
export const AUTH_FETCH_ME_FAILURE = 'auth/FETCH_ME_FAILURE';

export const AUTH_UPDATE_ME_REQUEST = 'auth/UPDATE_ME_REQUEST';
export const AUTH_UPDATE_ME_SUCCESS = 'auth/UPDATE_ME_SUCCESS';
export const AUTH_UPDATE_ME_FAILURE = 'auth/UPDATE_ME_FAILURE';

export const AUTH_CHANGE_PASSWORD_REQUEST = 'auth/CHANGE_PASSWORD_REQUEST';
export const AUTH_CHANGE_PASSWORD_SUCCESS = 'auth/CHANGE_PASSWORD_SUCCESS';
export const AUTH_CHANGE_PASSWORD_FAILURE = 'auth/CHANGE_PASSWORD_FAILURE';

export const AUTH_SETUP_SUPER_ADMIN_REQUEST = 'auth/SETUP_SUPER_ADMIN_REQUEST';
export const AUTH_SETUP_SUPER_ADMIN_SUCCESS = 'auth/SETUP_SUPER_ADMIN_SUCCESS';
export const AUTH_SETUP_SUPER_ADMIN_FAILURE = 'auth/SETUP_SUPER_ADMIN_FAILURE';
